<i *ngIf="icon" [uiType]="icon" ui-icon></i>
<div class="ui-label-content">
  <ng-content></ng-content>
</div>
